import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Intro from './components/Intro';
import Story from './components/Story';
import Terroir from './components/Terroir';
import Wines from './components/Wines';
import Philosophy from './components/Philosophy';
import Symbol from './components/Symbol';
import Contact from './components/Contact';
import Footer from './components/Footer';

const LandingPage = () => (
  <div className="bg-cream">
    <div className="noise-overlay" aria-hidden="true" />
    <Navbar />
    <main>
      <Hero />
      <Intro />
      <Story />
      <Terroir />
      <Wines />
      <Philosophy />
      <Symbol />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
